import angular from 'angular';
const teamsFieldId = 'b5a73c11-4b57-436c-9236-2424594e16fe';
angular.module('cloudX').directive('cxTeamInputXedit', [
  '$filter',
  'resourceFactorySvc',
  'flySvc',
  'ModalService',
  function($filter, resourceFactorySvc, flySvc, ModalService) {
    return {
      restrict: 'E',
      template: `<div>
          <div ng-if="readonly" >
            <span ng-bind="displayValue"></span>
            <a ng-click="openAccessDialog(); $event.stopPropagation();" ng-show="value && value.length && relation" cx-security="'Users:r'" class="margin5L" title="{{('Show employees with access'|translate)}}">
              <i class="fa fa-info-circle"></i>
            </a>
          </div>
          <form data-editable-form name="tagsForm" class="tagsForm" onbeforesave="beforeSave($data.tags, tagsForm)" ng-if="!readonly">
            <div editable-tags-input="innerValue" data-e-form="tagsForm" data-e-name="tags" name="tags" e-replace-spaces-with-dashes="false" e-placeholder="{{('Add a team'|translate)}}" e-add-from-autocomplete-only="false" e-min-length="1" e-on-invalid-tag="invalidTag($tag)" e-on-tag-adding="addingTag($tag)">
              <a href="" ng-click="readValue(); tagsForm.$show();" ng-show="!tagsForm.$visible" title="{{('Edit teams'|translate)}}">
                <span ng-show="displayValue">{{displayValue}}</span>
                <i class="glyphicon glyphicon-pencil" ng-hide="displayValue"></i>
                <a ng-click="openAccessDialog(); $event.stopPropagation();" ng-show="value && value.length && relation" cx-security="'Users:r'" class="margin5L" title="{{('Show employees with access'|translate)}}">
                  <i class="fa fa-info-circle"></i>
                </a>
              </a>
              <editable-tags-input-auto-complete min-length="1" source="loadTags($query)" load-on-down-arrow="true"></editable-tags-input-auto-complete>
            </div>
            <div class="margin5T" ng-show="tagsForm.$visible && lockedTeams.length">
              <small class="text-muted">{{('TeamsSetByCompany'|translate)}}</small>
              <ul class="list-unstyled margin0">
                <li ng-repeat="team in lockedTeams">{{team.name}}</li>
              </ul>
            </div>
            <div class="buttons">
              <span ng-show="tagsForm.$visible">
                <button type="submit" class="btn btn-inverse btn-xs" ng-disabled="tagsForm.$waiting" data-translate>Save</button>&nbsp;
                <button type="button" class="btn btn-default btn-xs" ng-disabled="tagsForm.$waiting" ng-click="tagsForm.$cancel()" data-translate>Cancel</button>
              </span>
            </div>
          </form>
        </div>`,
      scope: {
        value: '=data',
        relation: '=relation',
        save: '&',
        readonly: '=?',
        allowAllTeams: '=?',
      },
      link: function(scope, element, attrs) {
        scope.innerValue = [];
        scope.lockedTeams = [];
        scope.tags = null;
        scope.displayValue = '';
        scope.loadTags = function(search) {
          if (scope.tags !== null) return $filter('filter')(scope.tags, search);

          const endpoint = scope.allowAllTeams
            ? resourceFactorySvc.get('team').flatTeams
            : resourceFactorySvc.get('team').myTeams;

          return endpoint({}, function(data) {
            scope.tags = data.map(function(el) {
              return {
                ...el,
                text: el.name,
              };
            });
          }).$promise.then(function() {
            return $filter('filter')(scope.tags, search);
          });
        };
        scope.setDisplayValue = function(value) {
          if (typeof value === 'string') value = JSON.parse(value);
          scope.displayValue = (value || []).map(x => x.name).join(', ');
        };
        scope.invalidTag = function(tag) {
          flySvc.error('msgChooseExistingTeamFromList');
        };
        scope.addingTag = function(tag) {
          if (scope.tags === null) return false;
          if (tag.id) return true;
          var option = scope.tags.find(x => x.text.toLowerCase() === tag.text.toLowerCase());
          if (!option) return false;
          return true;
        };
        scope.readValue = function() {
          var value = scope.value;
          if (typeof value === 'string') value = JSON.parse(value);
          if (angular.isArray(value)) {
            scope.innerValue = value
              .filter(function(el) {
                return !el.isCompanyLocked || el.keepAfterCompanyChange;
              })
              .map(function(el) {
                return {
                  ...el,
                  text: el.name,
                };
              });
            scope.lockedTeams = value.filter(function(el) {
              return el.isCompanyLocked;
            });
          } else {
            scope.innerValue = [];
            scope.lockedTeams = [];
          }
        };
        scope.$watch(
          'value',
          function(newValue, oldValue) {
            scope.readValue();
            scope.setDisplayValue(newValue);
          },
          true,
        );
        scope.beforeSave = function(data, form) {
          let invalid =
            form.$invalid || (form.$error.leftoverText && form.$error.leftoverText.length > 0);

          data.map(x => {
            if (!x.id) invalid = true;
          });

          if (invalid) {
            flySvc.error('msgChooseExistingTeamFromList');
            return '';
          }

          return scope
            .save({
              $data: data.map(function(x) {
                return {
                  id: x.id,
                  name: x.name,
                  code: x.code,
                };
              }),
            })
            .then(
              result => {
                if (result?.changes?.[teamsFieldId]?.length === 0 && scope.relation) {
                  flySvc.proposal('msgTeamListEmpty');
                }
                return false;
              },
              error => {
                return '';
              },
            );
        };
        scope.openAccessDialog = function() {
          ModalService.showModal({
            template: require('../../relations/dialogs/employeeAccessDialog.html'),
            controller: 'EmployeeAccessDialogCtrl',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              relationId: scope.relation ? scope.relation.id : null,
              invoiceStreamId: null,
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
          });
        };
      },
    };
  },
]);
